import './App.css';
import ProductGallery from './components/Product Gallery';

function App() {
  console.log("Hello, and welcome to the developer console")
  return (
    <div className="App">
      <header className="App-container">
        <div className='App-title'>
          <span></span>
        </div>
        <div className='App-span'>
        </div>
        <div className='App-Gallery'>
          <ProductGallery />
        </div>
      </header>
    </div>
  );
}

export default App;
